import { useEffect } from "react"
import { useAuth } from "@/hooks/useAuth"
import { useNavigate } from "react-router-dom"
import { Meh } from "lucide-react"

const Screen_Out = () => {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        await signOut()
      } finally {
        navigate('/auth')
      }
    }, 6000)
    return () => clearTimeout(t)
  }, [signOut, navigate])

  return (
    <div className="min-h-screen w-screen bg-gradient-to-br from-green-500 to-green-700 flex items-center justify-center p-6">
      <div className="w-full max-w-xl text-center text-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-6"></div>
        <div className="flex items-center justify-center gap-3 mb-1">
          <h1 className="text-6xl sm:text-7xl font-extrabold tracking-tight">OPS!</h1>
          <Meh className="h-16 w-16 sm:h-20 sm:w-20 text-white" aria-hidden />
        </div>
        <p className="mt-4 text-base sm:text-lg">Agradecemos sua visita. Esperamos que retorne em breve</p>
      </div>
    </div>
  )
}

export default Screen_Out
